import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useState, useEffect } from "react";
import { Button, Modal, Row, Col, Icon, HoverOverlay, } from "../../index";
import { FormTextField } from "../../forms";
import { RSForm } from "../../index";
import { addComponent, defineComponent } from "../utils";
function ComponentPickerModal(props) {
    const { open, setOpen, zone, setZone, zoneId, ds, currentWidgets, setCurrentWidgets, dataUrl, } = props;
    const [componentType, setComponentType] = useState("");
    const [widgetType, setWidgetType] = useState("");
    const [title, setTitle] = useState("");
    const [idError, setIdError] = useState(false);
    const [fieldError, setFieldError] = useState(false);
    function reset() {
        setComponentType("");
        setWidgetType("");
        setTitle("");
        setIdError(false);
    }
    function checkStates() {
        setIdError(false);
        setFieldError(false);
        let validId = true;
        let validField = true;
        if (title === "") {
            setIdError(true);
            validId = false;
        }
        if (componentType === "" || widgetType === "") {
            setFieldError(true);
            validField = false;
        }
        return validId && validField;
    }
    useEffect(() => {
        if (!open) {
            reset();
        }
    }, [open]);
    const onAddComponent = async () => {
        if (checkStates()) {
            const highestOrder = Object.values(zone.components).reduce((max, component) => {
                return component.data.order > max ? component.data.order : max;
            }, 0);
            const nextOrder = highestOrder + 1;
            //All components added are set with portal as baseUrl
            const newComponent = await addComponent(ds, zone.type, title, nextOrder, componentType, widgetType, zoneId, dataUrl);
            //This adds the component to the zone
            defineComponent({
                id: newComponent.newComponentId,
                size: widgetType,
                type: componentType,
                order: nextOrder,
            }, zone);
            zone.order = [...zone.order, newComponent.newComponentId];
            // This adds the component to the currentWidgets to be rendered
            setCurrentWidgets([
                ...currentWidgets,
                {
                    componentId: newComponent.newComponentId,
                    order: nextOrder,
                    componentZoneId: newComponent.newComponentZoneId,
                    baseUrl: dataUrl,
                    componentType: componentType,
                    filter: { and_: {} },
                    title: title,
                    objectType: zone.type,
                    config: {},
                    widgetType: widgetType,
                    filterPassThrough: false,
                },
            ]);
            setZone({ ...zone });
            reset();
            setOpen(false);
        }
    };
    const plusButton = (_jsx(Button, { type: "success", onClick: onAddComponent, icon: "plus", position: "right" }));
    const componentOptions = [
        {
            type: "count",
            text: "Count",
            icon: "hashtag",
        },
        {
            type: "sunburst",
            text: "Sunburst",
            icon: "chart-pie",
        },
        {
            type: "table",
            text: "Table",
            icon: "table",
        },
    ];
    const sizeOptions = [
        {
            type: "sm",
            text: "Small",
            disabled: componentType === "count" || componentType == "sunburst" ? false : true,
        },
        {
            type: "md",
            text: "Medium",
            disabled: componentType === "count" ? true : false,
        },
        {
            type: "lg",
            text: "Large",
            disabled: componentType === "count" ? true : false,
        },
    ];
    return (_jsx(Modal, { open: open, size: "md", setOpen: setOpen, actionButton: plusButton, overflow: false, className: "dashboard-component-modal-full", children: _jsxs(_Fragment, { children: [_jsxs("h6", { children: ["Select Component ", _jsx("span", { style: { color: "red" }, children: "*" })] }), _jsx(Row, { children: componentOptions.map((option, index) => {
                        return (_jsx(Col, { lg: 4, md: 4, sm: 12, className: "tol-button-col", children: _jsxs("div", { className: componentType !== option.type
                                    ? "tol-component-modal-bttn"
                                    : "tol-component-modal-bttn-clicked", onClick: () => setComponentType(option.type), children: [_jsx(Icon, { icon: option.icon, size: "4x" }), _jsx("h6", { children: option.text })] }) }, index));
                    }) }), _jsx("br", {}), _jsxs("h6", { children: ["Select Size ", _jsx("span", { style: { color: "red" }, children: "*" })] }), _jsx(Row, { children: sizeOptions.map((option, index) => {
                        return (_jsx(Col, { lg: 4, md: 4, sm: 12, className: "tol-button-col", children: !option.disabled ? (_jsx("div", { className: widgetType !== option.type
                                    ? "tol-component-modal-bttn"
                                    : "tol-component-modal-bttn-clicked", onClick: () => setWidgetType(option.type), children: _jsx("h5", { children: option.text }) })) : (_jsx(HoverOverlay, { contents: "Currently unavailable for this Component", children: _jsx("div", { className: "tol-component-modal-bttn-disabled", children: _jsx("h5", { children: option.text }) }) })) }, index));
                    }) }), _jsx("br", {}), _jsxs("h6", { children: ["Enter Title ", _jsx("span", { style: { color: "red" }, children: "*" })] }), _jsx(RSForm, { fluid: true, children: _jsx(FormTextField, { id: "component-title", onChange: (value) => setTitle(value), name: "Board Title", placeholder: `Title`, label: "", value: title }) }), idError ? (_jsx("p", { className: "tol-modal-error", children: "Title cannot be blank" })) : null, fieldError ? (_jsx("p", { className: "tol-modal-error", children: "Please ensure all mandatory fields are filled" })) : null] }) }));
}
export default ComponentPickerModal;
